import { css, Theme } from '@emotion/react'

export const similarPostsWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};
`
